import { useDispatch } from "react-redux";
import { useEffect, useRef } from "react";
import { useController } from "react-hook-form";
import { VideoImageAPI } from "../../../services/videos-image";
import BasicModal from "../../modal/modal";
import { setModalOpen } from "../../../store/modal/slice";
import { setDeleteImage } from "../../../store/image/slice";
import { Close, Clear, ZoomOutMap } from "@mui/icons-material";
import Toast from "../../../helpers/status-text";

import styles from "./styles.module.scss";

const Image = ({
  name,
  control,
  className,
  status,
  image,
  error,
  allowVideo = false,
  title = "Ավելացնել լուսանկար",
}) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const {
    field: { name: fieldName, onChange },
  } = useController({
    name,
    control,
  });

  const BASE_URL = process.env.REACT_APP_BASE_URL_IMG;

  const changeSectionItem = async (e) => {
    try {
      const { files } = e.target;
      const selected = Array.from(files);
      onChange(selected);
      await dispatch(
        VideoImageAPI.postImage({ image: files, allowVideo: allowVideo })
      ).unwrap();
    } catch (error) {
      Toast.error(error.message);
    }
  };

  useEffect(() => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [status, dispatch, image]);

  const closeModal = () => {
    dispatch(setModalOpen(false));
  };

  const handleImageDelete = (image) => {
    dispatch(setDeleteImage(image));
  };

  return (
    <div className={className}>
      <div
        className={styles.img_input}
        onClick={() => fileInputRef.current.click()}
      >
        <input
          type="file"
          name={fieldName}
          control={control}
          ref={fileInputRef}
          onChange={changeSectionItem}
          accept={allowVideo ? "image/*,video/*" : "image/*"}
        />
        <p>{title}</p>
      </div>
      {image
        ? (() => {
            const fileUrl = `${BASE_URL}${image}`;
            const isVideo = fileUrl.match(/\.(mp4|webm|ogg|mov|avi)$/i);

            if (isVideo) {
              return (
                <>
                  <video
                    controls
                    height={200}
                    src={fileUrl}
                    className={styles.preview}
                  />
                  <Clear
                    className={styles.clear_icon}
                    onClick={() => handleImageDelete(image)}
                  />
                  <BasicModal
                    color="text"
                    title="Մեծացնել"
                    startIcon={<ZoomOutMap />}
                    className={styles.modal}
                  >
                    <div className={styles.modal_content}>
                      <video
                        height={430}
                        className={styles.big_img}
                        src={fileUrl}
                        controls
                      />
                      <Close
                        color="error"
                        fontSize="large"
                        onClick={() => closeModal()}
                        className={styles.close_icon}
                      />
                    </div>
                  </BasicModal>
                </>
              );
            } else {
              return (
                <>
                  <img alt={image} className={styles.preview} src={fileUrl} />
                  <Clear
                    className={styles.clear_icon}
                    onClick={() => handleImageDelete(image)}
                  />
                  <BasicModal
                    color="text"
                    title="Մեծացնել"
                    className={styles.modal}
                    startIcon={<ZoomOutMap />}
                  >
                    <div className={styles.modal_content}>
                      <img
                        alt={image}
                        height={430}
                        src={fileUrl}
                        className={styles.big_img}
                      />
                      <Close
                        color="error"
                        fontSize="large"
                        onClick={() => closeModal()}
                        className={styles.close_icon}
                      />
                    </div>
                  </BasicModal>
                </>
              );
            }
          })()
        : null}
      <p className={styles.error}>{error}</p>
    </div>
  );
};

export default Image;
